module.exports = __webpack_public_path__ + "static/img/yy_vpn.72e4a82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yy_vpn.png
// module id = s++l
// module chunks = 1